export default __webpack_public_path__ + "static/media/icon-trade.6e96ea3a.svg";